// extracted by mini-css-extract-plugin
export default {"userImg":"userRp_userImg__z6GN2","imgContainer":"userRp_imgContainer__96kKf"};